import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LogoutPage() {
  const navigate = useNavigate();
  useEffect(() => {
    // props.logoutUser();
    // TODO: implement LoginService.logoutUser()
    sessionStorage.setItem("user", null);

    setTimeout(() => {
      navigate("/");
    }, 3000);
  });
  return <div>Good bye!</div>;
}
